'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "overlay", "placement", "withPortal", "closeOverlay", "domNode"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { deprecatedOverlayDirections, mapPhysicalToLogicalDirections } from "../../styles/mixins/index.mjs";
import { OverlayPortal } from "../OverlayPortal/index.mjs";
import { Overlay } from "./Overlay.mjs";
import { Trigger } from "./Trigger.mjs";
import { physicalDirectionWarning } from "../../logging.mjs";
import { isWindowDefined } from "../../utils.mjs";
var OverlayTriggerComponent = /*#__PURE__*/React.forwardRef(function OverlayTriggerComponent(_ref, ref) {
  var children = _ref.children,
    overlay = _ref.overlay,
    placement = _ref.placement,
    withPortal = _ref.withPortal,
    closeOverlay = _ref.closeOverlay,
    domNode = _ref.domNode,
    props = _objectWithoutProperties(_ref, _excluded);
  if (placement) {
    physicalDirectionWarning(placement, 'OverlayTrigger');
  }
  return /*#__PURE__*/React.createElement(Trigger, Object.assign({}, props, {
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.OverlayTrigger
  }), children, overlay && (withPortal && isWindowDefined() && typeof ref !== 'function' && ref !== null && ref !== void 0 && ref.current ? /*#__PURE__*/React.createElement(OverlayPortal, {
    overlayPosition: ref.current.getBoundingClientRect(),
    closeOverlay: closeOverlay,
    domNode: domNode
  }, /*#__PURE__*/React.createElement(Overlay, {
    $placement: mapPhysicalToLogicalDirections(placement)
  }, overlay)) : /*#__PURE__*/React.createElement(Overlay, {
    $placement: mapPhysicalToLogicalDirections(placement)
  }, overlay)));
});
var overlayTriggerHelpers = _objectSpread({}, deprecatedOverlayDirections);
export var OverlayTrigger = Object.assign(OverlayTriggerComponent, overlayTriggerHelpers);